const NavLinks = {
  TIMES_ANOMALY_ROOT: '/timesanomaly',
  TIMES_ANOMALY_SELECTION: '/timesanomaly/selection',
  TIMES_ANOMALY_SEARCH: '/timesanomaly/search'
};

export default NavLinks;